import { recordSequence } from '@/utils/recordSequence';
import Reveal from '@/components/base/Reveal';

function RecordSequence() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100 px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="inline-flex items-center gap-2 px-3 h-8 rounded-full border border-background-300 bg-background-50 mb-6">
            <i className="ri-fingerprint-line text-[14px] text-primary-600"></i>
            <span className="text-[11px] font-data tracking-[0.16em] text-foreground-600">
              EVIDENCE, IN ORDER
            </span>
          </div>

          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
            <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[32px] leading-[1.08] sm:text-[42px] lg:text-[48px] max-w-[720px]">
              The Record Is A Sequence, Not A Summary.
            </h2>
            <p className="text-[14px] leading-relaxed text-foreground-600 max-w-[440px] lg:pb-2">
              Each mark below is one closed trade, kept in the order it happened. Wins and losses
              sit side by side because that is how the record actually unfolded — nothing was
              reordered or removed to look smoother.
            </p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-12 rounded-lg border border-background-300 bg-background-50 p-5 md:p-7">
            <div className="flex flex-wrap gap-[3px]">
              {recordSequence.map((mark) => (
                <span
                  key={mark.id}
                  title={`${mark.profit ? 'Win' : 'Loss'} ${mark.result}`}
                  className={`w-1.5 h-8 md:h-10 rounded-[2px] cursor-default transition-transform duration-200 hover:scale-y-110 ${
                    mark.profit ? 'bg-profit-600/85' : 'bg-loss-500/85'
                  }`}
                ></span>
              ))}
            </div>

            <div className="mt-6 pt-5 border-t border-background-200 flex flex-wrap items-center justify-between gap-4">
              <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[12px] text-foreground-600">
                <span className="flex items-center gap-2">
                  <span className="w-2.5 h-2.5 rounded-[2px] bg-profit-600/85"></span>
                  Profit
                </span>
                <span className="flex items-center gap-2">
                  <span className="w-2.5 h-2.5 rounded-[2px] bg-loss-500/85"></span>
                  Loss
                </span>
              </div>
              <span className="text-[11px] font-data tracking-[0.14em] text-foreground-400">
                LEFT TO RIGHT · FIRST TO LAST CLOSED TRADE
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default RecordSequence;